module.exports = __webpack_public_path__ + "static/media/DIGITALIS-EXTIME-LOGOTYPE-2021-11.8e6df033.png";